
import { mapActions, mapMutations, mapState } from "vuex";

export default {
    name: "popup_auditorium",
    props: ["room"],
    data (){
        return {
            question: null,

            selectedLang: "en",
            selectedTab: "live_chat",
            selectedStream: "main",
            isFinishCalculated: false,

            isOpenSurvey: false,
        }
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
            settingItem: state => state.setting,
            pollingItem: state => state.live_polling.item,
        }),
        streamUrl(){
            return this.settingItem[`${ this.room }_stream_url${ this.selectedStream == "main"? "" : "_alt" }${ this.selectedLang == "en"? "" : "_cn" }`];
        },
        isShowLiveChat(){
            return !!this.settingItem.is_show_live_chat;
        }
    },
    mounted(){
        window.addEventListener("resize", this.onHandleWindowResize.bind(event, 0));
        this.onHandleWindowResize(500);

        if(!this.isShowLiveChat) this.selectedTab = "live_polling";

        this.$store.commit("auth/setCurrentRoom", this.roomItems[this.room]); 
    },
    methods: {
        onHandleWindowResize(delayTime){
            setTimeout(() => {
                const $win = $(window);
                const winW = $win.width();
                const winH = $win.height();

                const streamHeight = $("#stream_container").height();
                const tabSelectionHeight = $("#tab_selection_box").height();
                const streamSelectionHeight = $("#stream_selection_box").height();

                if(this.source == "open_link"){
                    $("body").css("padding", "20px");
                    $("#tab_selection_content").css("height", winH - 40);
                }else if(winW > 992){
                    $("#tab_selection_content").css("height", streamHeight - tabSelectionHeight - streamSelectionHeight - 12);
                }else{
                    $("#tab_selection_content").css("height", "500px");
                }

                this.isFinishCalculated = true;
            }, delayTime);
        },
        onSelectLang(item){
            this.selectedLang = item;
        },
        onSelectTab(item){
            this.selectedTab = item;
            clearInterval(this.blinkInterval);
            this.blinkInterval = null;
            this.onHandleTriggerAnalytics(`select@${ item }@${ this.room }`); 
        },
        onSelectStream(item){
            this.selectedStream = item;
            this.onHandleTriggerAnalytics(`select@${ item == 'main'? 'main_stream' : 'alternate_stream' }@${ this.room }`); 
        },
        onClickSubmitQuestionBtn(){
            if(!this.isSubmittingQuestion && this.question){
                this.isSubmittingQuestion = true;

                this.onHandleTriggerAnalytics(`send@question@${ this.room }`); 

                this.$socket.emit("submitPostQuestion", { room: this.room, question: this.sanitizeText(this.question) }, (res) => {
                    console.log("submitPostQuestionCallback", res);
                    this.question = "";

                    this.$swal({
                        title: "Thank you for your question.",
                        icon: "success",
                    })
                    
                    this.isSubmittingQuestion = false;
                });
            }
        },
        onClickSurveyBtn(){
            this.isOpenSurvey = true;
            this.onHandleTriggerAnalytics(`open@survey@${ this.room }`); 
        },
        onClickCloseBtn(){
            this.$emit("update:currentPopupItem", null);
            this.onHandleTriggerAnalytics(`close@live_stream@${ this.room }`); 
        },
    },
    watch: {
        "pollingItem"(){
            if(this.pollingItem && this.selectedTab != "live_polling" && !this.blinkInterval){
                this.blinkInterval = setInterval(() => {
                    $("#polling_btn").toggleClass("btn-tab-active");
                }, 800);

                setTimeout(() => {
                    clearInterval(this.blinkInterval);
                    this.blinkInterval = null;
                }, 8000);
            }
        },
        "blinkInterval"(){
            $("#polling_btn").css({"transition": this.blinkInterval? "background 0.5s linear" : "none"});
        },
        "selectedLang"(){
            this.onHandleTriggerAnalytics(`change_language@${ this.selectedLang }@live_stream@${ this.room }`); 
        },
        "isShowLiveChat"(){
            if(!this.isShowLiveChat && this.selectedTab == "live_chat") this.selectedTab = "live_polling";
            this.onHandleWindowResize(0);
        }
    }
}
